import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';


@Injectable()
export class CypherService {

  constructor() { }

  private static parseItem(item: any) {
    if (item === null || item === undefined) {
      return null;
    }
    return JSON.parse(item);
  }

  public static encrypt(data: any, key: string ): string {
    const cipherText = CryptoJS.AES.encrypt(JSON.stringify(data), key);
    return cipherText.toString();
  }

  public static decrypt(cipherText: string, key: string) {
    const bytes = CryptoJS.AES.decrypt(cipherText, key.trim()).toString(CryptoJS.enc.Utf8);
    return CypherService.parseItem(bytes.toString());
  }

    public encryptHS256(data: any, secretKey: string): string {
        const header = {
            alg: 'HS256',
            typ: 'JWT'
        };
        const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
        const encodedHeader = this.base64Parser(stringifiedHeader);
        const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
        const encodedData = this.base64Parser(stringifiedData);
        const token = `${encodedHeader}.${encodedData}`;
        const signature = CryptoJS.HmacSHA256(token, secretKey);
        const encodedSignature = this.base64Parser(signature);
        return `${token}.${encodedSignature}`;
    }

    private base64Parser(source): string {
        // Encode in classical base64
        let encodedSource = CryptoJS.enc.Base64.stringify(source);
        // Remove padding equal characters
        encodedSource = encodedSource.replace(/=+$/, '');
        // Replace characters according to base64url specifications
        encodedSource = encodedSource.replace(/\+/g, '-');
        encodedSource = encodedSource.replace(/\//g, '_');
        return encodedSource;
    }

    public hashMd5(data: string): string {
        return CryptoJS.MD5(data).toString();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/cypher.service.ts